
/**
 * @desc  函数防抖---“立即执行版本” 和 “非立即执行版本” 的组合版本
 * @param  func 需要执行的函数
 * @param  wait 延迟执行时间（毫秒）
 * @param  immediate---true 表立即执行，false 表非立即执行
 **/
export function debounce(func, wait, immediate) {
    let timer;

    return function () {
        let context = this;
        let args = arguments;

        if (timer) clearTimeout(timer);
        if (immediate) {
            var callNow = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, wait)
            if (callNow) func.apply(context, args)
        } else {
            timer = setTimeout(function () {
                func.apply(context, args)
            }, wait);
        }
    }
}

// 休眠
export function sleep(delay) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            try {
                resolve(1)
            } catch (e) {
                reject(0)
            }
        }, delay);
    })
}


// 生成随机单播Mac地址
export function generateRandomMac() {
    const mac = [
        (0x52).toString(16),
        (0x54).toString(16),
        (0x00).toString(16),
        Math.floor((Math.random() * 0xff)).toString(16),
        Math.floor((Math.random() * 0xff)).toString(16),
        Math.floor((Math.random() * 0xff)).toString(16)
    ];

    return mac.join(':');
}